import { render, staticRenderFns } from "./RegionalMemberOfficer.vue?vue&type=template&id=4ac1a81a&"
import script from "./RegionalMemberOfficer.vue?vue&type=script&lang=js&"
export * from "./RegionalMemberOfficer.vue?vue&type=script&lang=js&"
import style0 from "./RegionalMemberOfficer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports